var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOpenDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H4C2.89543 22 2 21.1046 2 20V9.049C2.03375 8.37786 2.39728 7.76686 2.971 7.41699L10.971 2.61699C11.6041 2.23737 12.3949 2.23737 13.028 2.61699L21.028 7.41699C21.6292 7.77977 21.9976 8.42984 22 9.13199V20C22 21.1046 21.1046 22 20 22ZM4 9.86799V20H20V9.86799L12 15.201L4 9.86799ZM12 4.33199L5.316 8.34199L12 12.798L18.683 8.34199L12 4.33199Z",
    fill: "#f9f9f9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenDark);
export default __webpack_public_path__ + "static/media/mail_open_dark.93ebe420.svg";
export { ForwardRef as ReactComponent };